import React from 'react';
import styled from 'styled-components';
import {
  Navigation,
  A11y,
  Pagination,
} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'; // eslint-disable-line import/no-unresolved
import 'swiper/css'; // eslint-disable-line import/no-unresolved
import 'swiper/css/navigation'; // eslint-disable-line import/no-unresolved
import 'swiper/css/pagination'; // eslint-disable-line import/no-unresolved
import Container from 'gatsby-theme-core/src/components/container';
import Image from 'gatsby-theme-core/src/components/image';

const breakpoint = 576;

const PartnersLogosSlider = ({ partners }) => (
  <SwiperWrapper>
    <Container>
      <Swiper
        modules={[Navigation, A11y, Pagination]}
        navigation
        pagination={{ clickable: true }}
        watchOverflow
        slidesPerView={2.3}
        spaceBetween={15}
        centeredSlides
        loop
        breakpoints={{
          [breakpoint]: {
            slidesPerView: 5,
            spaceBetween: 30,
            centeredSlides: false,
          },
        }}
      >
        {partners.map(({ id, title, logo }) => (
          <SwiperSlide key={id}>
            <Partner>
              <ImageWrapper>
                <StyledImage
                  key={id}
                  image={logo}
                  alt={title}
                />
              </ImageWrapper>
            </Partner>
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  </SwiperWrapper>
);

const StyledImage = styled(Image)`
  max-width: 7.778rem;
  max-height: 7.778rem;
  margin: 0 auto;
`;
const ImageWrapper = styled.div`
  width: 100%;
`;
const Partner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding: 1rem;
  min-height: 8rem;
  max-width: 100%;
  border: 1px solid ${({ theme }) => theme.grayLightColor};
  margin-bottom: 2rem;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    min-height: 3rem;
  }

  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    min-height: 5rem;
  }

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    min-height: 8rem;
  }
`;

const SwiperWrapper = styled.div`
  .swiper-container {
    margin-bottom: 0;
  }
  .swiper-pagination {
    bottom: 0;
  }
  .swiper-pagination-bullet {
    width: .75rem;
    height: .75rem;
    border-radius: 100%;
  }
`;

export default styled(PartnersLogosSlider)``;
